/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_Q2Inputs */

const en_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many invite codes can I enter?`)
};

const ar_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كم رمز دعوة يمكنني إدخاله؟`)
};

const de_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Einladungscodes kann ich eingeben?`)
};

const es_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos códigos de invitación puedo introducir?`)
};

const fr_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de codes d’invitation puis-je saisir ?`)
};

const it_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti codici invito posso inserire?`)
};

const ja_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードはいくつ入力できますか？`)
};

const ko_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드는 몇 개까지 입력할 수 있나요?`)
};

const pt_br_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos códigos de convite posso inserir?`)
};

const ru_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сколько кодов приглашения можно ввести?`)
};

const th_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฉันกรอกรหัสเชิญได้กี่รหัส?`)
};

const tr_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaç davet kodu girebilirim?`)
};

const zh_cn_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以输入几组别人的邀请码？`)
};

const zh_tw_invite_page_faq_q2 = /** @type {(inputs: Invite_Page_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以輸入幾組別人的邀請碼？`)
};

/**
* | output |
* | --- |
* | "How many invite codes can I enter?" |
*
* @param {Invite_Page_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_q2 = /** @type {((inputs?: Invite_Page_Faq_Q2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_Q2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_q2(inputs)
	if (locale === "ar") return ar_invite_page_faq_q2(inputs)
	if (locale === "de") return de_invite_page_faq_q2(inputs)
	if (locale === "es") return es_invite_page_faq_q2(inputs)
	if (locale === "fr") return fr_invite_page_faq_q2(inputs)
	if (locale === "it") return it_invite_page_faq_q2(inputs)
	if (locale === "ja") return ja_invite_page_faq_q2(inputs)
	if (locale === "ko") return ko_invite_page_faq_q2(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_q2(inputs)
	if (locale === "ru") return ru_invite_page_faq_q2(inputs)
	if (locale === "th") return th_invite_page_faq_q2(inputs)
	if (locale === "tr") return tr_invite_page_faq_q2(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_q2(inputs)
	return zh_tw_invite_page_faq_q2(inputs)
});